export default __webpack_public_path__ + "static/media/arrow-blue.c4dc8c37.svg";